import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 590px;
  flex-direction: column;


`
export const CommunicationImageWrapper = styled.div`

`
export const Title = styled.div`
display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`
export const Text = styled.div`
color: var(--blue, #2555EF);
font-feature-settings: 'clig' off, 'liga' off;
font-family: var(--CommunicationCreatedAutomationDoneTextFont-family);
font-size: 22px;
font-style: normal;
font-weight: 500;
line-height: 32px;
`
// export const Description = styled.div`
// color: var(--dark-blue, #002E5C);
// font-family: Poppins;
// font-size: 16px;
// font-style: normal;
// font-weight: 400;
// line-height: normal;
// padding-top: 16px;
// padding-top: 16px;

// `


export const SummaryDetails = styled.div`
 background-color: #F3F6F9;
  width:414px;
  height:153.22px;
  display: flex;
  justify-content: start;
  align-items: center;
  border-radius: 10px;
  margin-top: 10px;
  ul{
    list-style-type: circle;
    color: #19426c;
    li {
      list-style: none;
      font-size: 16px;
      font-weight: 400px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 26rem;
      line-height: 34px;
  }
    li::before{
      content:"·";
      font-size:80px;
      vertical-align:middle;
      line-height:20px;    
      padding-right: 10px;
      color: #2555ef;
     
    }
  }

`